import React from "react";

const PlayIcon = (props: any) => {
  return (
    <svg width={30} height={31} fill="none" {...props}>
      <path
        fill="var(--color-icon-obscure)"
        stroke="var(--color-icon-obscure)"
        d="M26.963 15.5c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12Z"
        opacity={0.4}
      />
      <path
        fill="var(--color-icon-obscure)"
        stroke="var(--color-icon-obscure)"
        d="M18.463 13.72a2.29 2.29 0 0 1 1.175 2.066v.012c0 .87-.442 1.632-1.189 2.068l-3.623 2.087-.003.001a2.355 2.355 0 0 1-2.371 0 2.37 2.37 0 0 1-1.19-2.068v-4.188c0-.87.443-1.632 1.19-2.068a2.344 2.344 0 0 1 2.384 0l.002.002 3.625 2.087Z"
      />
    </svg>
  );
};

export default PlayIcon;
